export const formatNomeCidadao = (cidadao: { nome: string; nomeSocial?: string }) =>
  (cidadao.nomeSocial ?? cidadao.nome).titleCase()
